<div
  class="comments-container mat-elevation-z4"
  cdkDrag
  cdkDragBoundary="body"
  [class.embedded]="embedded || inDialog"
  [class.in-dialog]="inDialog">
  @if (!embedded && !inDialog) {
    <div
      class="close-button"
      (click)="close()">
      <mat-icon>close</mat-icon>
    </div>
  }
  <div
    class="head"
    cdkDragHandle
    [hidden]="embedded || inDialog">
    <p class="bold">Comments: {{ employeeName }}</p>
  </div>
  <div class="bar-wrapper">
    <ngx-simplebar
      #simpleBar
      class="primary-scrollbar-vertical no-space modal-appearance">
      <div class="comments">
        @for (comment of comments; track comment) {
          <coin-siemens-energy-comment
            class="animate__animated animate__bounceInRight"
            [comment]="comment"
            [user]="user"></coin-siemens-energy-comment>
        }
      </div>
    </ngx-simplebar>
  </div>
  <div class="add-comment">
    <coin-v2-text-input
      size="small"
      [placeholder]="'general.enter-comment' | translate"
      [(ngModel)]="commentText"
      (keyup.enter)="addComment()" />
    <mat-icon (click)="addComment()">send</mat-icon>
  </div>
</div>
